import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useQuery } from '@tanstack/react-query';
function fetchAuth0AccessToken() {
  return _fetchAuth0AccessToken.apply(this, arguments);
}
function _fetchAuth0AccessToken() {
  _fetchAuth0AccessToken = _asyncToGenerator(function* () {
    var _data$accessToken;
    var res = yield fetch('/api/auth/access-token');
    if (!res.ok) return null;
    var data = yield res.json();
    return (_data$accessToken = data.accessToken) !== null && _data$accessToken !== void 0 ? _data$accessToken : null;
  });
  return _fetchAuth0AccessToken.apply(this, arguments);
}
export function useAuth0AccessToken() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useQuery = useQuery({
      queryKey: ['auth0AccessToken'],
      queryFn: fetchAuth0AccessToken,
      enabled,
      staleTime: 4 * 60 * 1000,
      refetchInterval: query => query.state.status === 'error' ? false : 4 * 60 * 1000,
      retry: 1
    }),
    accessToken = _useQuery.data,
    isLoading = _useQuery.isLoading,
    error = _useQuery.error;
  return {
    accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : null,
    isLoading,
    error
  };
}